import stringToColor from 'string-to-color'
import convert from 'color-convert'

export const stringToHexColor = (text: string) => {
  const hex = stringToColor(text).replace('#', '')
  const [h, s, l] = convert.hex.hsl(hex)

  const pastelS = Math.min(s, 80)
  const pastelL = Math.max(l, 65)

  return `hsl(${h}, ${pastelS}%, ${pastelL}%)`
}
